import { snackbar } from 'components/notifications/notifications';

const copyToClipboard = (text, showNotification = true) => {
  navigator.clipboard.writeText(text);
  showNotification && snackbar(`"${text}" copied to clipboard`, 'success');
};

export default copyToClipboard;
